<template>
    <div class="w-100">
        <div class="card">
            <div class="card-header bg-primary text-white">
                <div class="card-title h5 m-0">{{$t('benchmarkType.title')}}</div>
            </div>
            <div class="card-body">
                <div class="grid-wrapper">
                    <kendo-datasource ref="datasource"
                                      :transport="transportSettings"
                                      :schema-model-id="'id'"
                                      :schema-model-fields="schemaModelFields"
                                      :schema-total="'total'"
                                      :schema-data="'data'"
                                      :page-size='defaultGridRows'
                                      :server-paging="true"
                                      :server-sorting="true"
                                      :server-filtering="true"
                                      :error="dataSourceError"
                                      :requestEnd="datasorceRequestEnd">
                    </kendo-datasource>

                    <kendo-grid ref="grid"
                                :data-source-ref="'datasource'"
                                :pageable="customGridOptions.pageable"
                                :navigatable="customGridOptions.navigatable"
                                :editable="customGridOptions.editable"
                                :filterable="customGridOptions.filterable"
                                :reorderable="customGridOptions.reorderable"
                                :resizable="customGridOptions.resizable"
                                :groupable="customGridOptions.groupable"
                                :allow-copy="customGridOptions.allowCopy"
                                :column-menu="customGridOptions.columnMenu"
                                :sortable-mode="customGridOptions.sortable.mode"
                                :sortable-allow-unsort="customGridOptions.sortable.allowUnsort"
                                :sortable-show-indexes="customGridOptions.sortable.showIndexes"
                                :selectable="customGridOptions.selectable"
                                :scrollable="customGridOptions.scrollable">
                        <kendo-grid-column :field="'id'"
                                           :title="$t('benchmarkType.gridHeaders.id')"
                                           :hidden="true">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'name'"
                                           :title="$t('benchmarkType.gridHeaders.name')">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'nameEn'"
                                           :title="$t('benchmarkType.gridHeaders.nameEn')">
                        </kendo-grid-column>
                        <kendo-grid-column :field="'code'"
                                           :title="$t('benchmarkType.gridHeaders.code')">
                        </kendo-grid-column>
                        <!--<kendo-grid-column :field="'deactivated'"
                                           :title="$t('benchmarkType.gridHeaders.deactivated')"
                                           :template="isDeactivatedTemplate">
                        </kendo-grid-column>-->
                        <kendo-grid-column :title="$t('actions')"
                                       field="btnsColumn"
                                       :sortable="false"
                                       :filterable="false"
                                       :template="btnsTemplate">
                        </kendo-grid-column>
                        <kendo-grid-column :command="command"
                                           :title="' '">
                        </kendo-grid-column>
                    </kendo-grid>
                </div>
            </div>
        </div>
        <JsonFormatter
            v-model="dataReferences"
            :show.sync="showDataReferences"
            :titleKey="'buttons.links.tooltipText'"
            @onClose="onDataReferencesClose"
        >
        </JsonFormatter>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BtnsTemplate from "@/components/grid/StandardBtnsTemplate";
    import { mapGetters } from 'vuex'
    import dataReferencesService from "@/services/dataReferences.service";
    import JsonFormatter from "@/components/common/json.formatter.modal.vue";

    export default {
        components: {
            JsonFormatter
        },
        data() {
            return {
                defaultGridRows: this.$store.getters.defaultGridRows,
                schemaModelFields: {
                    id: { name: 'id', from: 'id', type: 'number', editable: false, nullable: false, visible: false },
                    name: { name: 'name', from: 'name', type: 'string', editable: true, nullable: false, visible: true },
                    nameEn: { name: 'nameEn', from: 'nameEn', type: 'string', editable: true, nullable: true, visible: true },
                    code: { name: 'code', from: 'code', type: 'string', editable: false, nullable: true, visible: true },
                    deactivated: { name: 'deactivated', from: 'deactivated', type: 'boolean', editable: true, nullable: true, visible: true },
                },
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/BenchmarkType/list',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    create: {
                        url: this.$store.getters.baseUrl + '/api/BenchmarkType/create',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    update: {
                        url: this.$store.getters.baseUrl + '/api/BenchmarkType/update',
                        dataType: 'json',
                        type: 'PUT',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                dataReferences: "",
                showDataReferences: false,
            };
        },
        methods: {
            datasorceRequestEnd(e) {
                if (e.type === "create") {
                    e.sender.read()

                    this.$vs.notify({
                        title: '',
                        text: this.$t('createSuccess'),
                        color: 'success',
                        time: this.$store.getters.notificationDuration
                    })
                } else if (e.type === "update") {
                    e.sender.read()

                    this.$vs.notify({
                        title: '',
                        text: this.$t('updateSuccess'),
                        color: 'success',
                        time: this.$store.getters.notificationDuration
                    })
                }
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) };
                } else {
                    return kendo.stringify(options);
                }
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            isDeactivatedTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.deactivated ? 'badge-danger' : 'badge-success') + '">' + kendo.htmlEncode(dataItem.deactivated ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            refresh() {
                let grid = this.$refs.grid;
                if (grid) {
                    grid.kendoWidget().dataSource.read();
                }
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.grid,
                        btns:
                            [
                                {
                                    name: 'dataReferences',
                                    text: "",
                                    tooltip: this.$t('buttons.links.tooltipText'),
                                    class: 'btn btn-info',
                                    icon: "fas fa-link",
                                    show: this.$store.getters.claims.dataReferences.read,
                                    clickHandler: this.dataReferencesBtnClick
                                }
                            ]
                    }
                };
            },
            dataReferencesBtnClick(args) {
                if (!this.claims.dataReferences.read) {
                    return this.$router.push(`/unauthorized`);
                }

                return this.getDataReferences(args.id);
            },
            getDataReferences(id) {
                dataReferencesService
                    .checkReferences("N", "BenchmarkType", id, this.dataReferencesListCount, true)
                    .then((response) => {
                        if (response.data) {
                            this.dataReferences = response.data;
                        }

                        this.showDataReferences = true;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },
            onDataReferencesClose() {
                this.dataReferences = "";
                this.showDataReferences = false;
            }
        },
        computed: {
            ...mapGetters(['gridOptions', 'claims', 'dataReferencesListCount']),
            token: function () {
                return this.$store.getters.authToken;
            },
            toolbar: function () {
                return [{ name: 'create', text: this.$t('buttons.create.btnText') }]
            },
            hasEditRights() {
                return this.claims.nomenclatureTypes.create
                    || this.claims.nomenclatureTypes.update;
            },
            command() {
                const commands = [];
                if (this.hasEditRights) {
                    commands.push({ name: 'edit', text: this.$t('buttons.edit.btnText') });
                }

                return commands;
            },
            customGridOptions() {
                let options = {
                    ...this.gridOptions,
                    editable: {
                        mode: 'popup',
                        window: {
                            title: this.$t('person.gridTitle'),
                            animation: true
                        },
                        move: true
                    }
                }
                return options
            }
        }
    };
</script>
